import { useCallback } from 'react';
import { useNavigate } from '@tanstack/react-router';

import { components } from '@features/shared/api/account/clients';

export function useGoToGame(backUrl?: string) {
  const navigate = useNavigate();

  return useCallback(
    (game: components['schemas']['UserGameHistoryItemDto']) => {
      if (game.gameSource === 'FastGame') {
        navigate({
          to: '/game/pairing/$gameId',
          from: '/',
          params: {
            gameId: game.gameId,
          },
          state: { backUrl },
        });
        //
      } else if (game.gameSource === 'InviteGame' || !game.clubId || !game.tournamentId) {
        navigate({
          to: '/game/friend/$gameId/view',
          from: '/',
          params: {
            gameId: game.gameId,
          },
          state: { backUrl },
        });
      } else {
        navigate({
          to: '/club/$clubId/tournament/$tournamentId/game/$gameId',
          from: '/',
          params: {
            clubId: game.clubId,
            tournamentId: game.tournamentId,
            gameId: game.gameId,
          },
          state: { backUrl },
        });
      }
    },
    [navigate, backUrl],
  );
}
